import React, { useState } from 'react';
import Styled from 'styled';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { fromGlobalId } from 'graphql-relay';
import { FormattedMessage } from 'react-intl';

import { ViewerConsumer } from 'four-nets/user/viewer/viewer';
import FetchMoreButton from 'four-nets/ui-v2/fetch-more-button/fetch-more-button';
import feed from 'four-nets/icons/svg/icon_feed.svg';
import friendship from 'four-nets/icons/svg/icon_friendship.svg';
import proffesional from 'four-nets/icons/svg/icon_proffesional.svg';
import picture from 'four-nets/icons/svg/icon_picture.svg';
import subsection from 'four-nets/icons/svg/icon_sub-section.svg';

import AuthorSVGIcon from '../author-svg-icon/author-svg-icon';
import { AuthorActivityFragment } from './author-activity.graphql';
import defaultStyles from './author-activity.scss';

export interface Props extends AuthorActivityFragment {
    styles: typeof defaultStyles;
    onMoreGroups?: () => void;
}

function AuthorActivity(props: Props) {
    const {
        styles,
        onMoreGroups,
        groups,
        favoritedImagesCount,
        username,
        photoBlogPostsCount,
        forumMessagesCount,
        bazaarProductsCount,
        profile,
    } = props;
    const [loadingOnMoreGroups, setLoadingOnMoreGroups] = useState(false);

    if (profile && profile.isVendor) {
        return null;
    }

    return (
        <React.Fragment>
            <div className={styles.activity}>
                <div className={styles.sectionTitle}>
                    <FormattedMessage id='ACTIVITY' />
                </div>
                <div className={styles.row}>
                    <AuthorSVGIcon src={feed} />
                    <FormattedMessage id='POSTS_IN_PHOTOBLOGS' values={{ count: photoBlogPostsCount }} />
                </div>
                <div className={styles.row}>
                    <AuthorSVGIcon src={friendship} />
                    <FormattedMessage id='POSTS_IN_FORUM' values={{ count: forumMessagesCount }} />
                </div>
                <a href={`/market/predajca/${username}/`} className={classnames(styles.row, styles.underline)}>
                    <AuthorSVGIcon src={proffesional} />
                    <FormattedMessage id='%(counter)s_ENTRIES' values={{ counter: bazaarProductsCount }} />
                </a>
                <ViewerConsumer>
                    {({ viewer }) => (
                        <React.Fragment>
                            {favoritedImagesCount && (viewer && viewer.username) === username ? (
                                <Link
                                    to={`/favourite-photos/${username}/`}
                                    className={classnames(styles.row, styles.underline)}
                                >
                                    <AuthorSVGIcon src={picture} />
                                    <FormattedMessage
                                        id='FAVORITED_IMAGES_COUNT'
                                        values={{ counter: favoritedImagesCount }}
                                    />
                                </Link>
                            ) : null}
                        </React.Fragment>
                    )}
                </ViewerConsumer>
            </div>
            <div className={styles.groups}>
                <div className={styles.sectionTitle}>
                    <FormattedMessage id='GROUPS' />
                </div>
                {groups &&
                    groups.edges &&
                    groups.edges.map(edge => {
                        if (!edge || !edge.node) {
                            return null;
                        }

                        const id = fromGlobalId(edge.node.id).id;

                        return (
                            <Link
                                key={id}
                                to={`/group/${id}/detail/`}
                                className={classnames(styles.row, styles.transformNone, styles.underline)}
                            >
                                <AuthorSVGIcon src={subsection} />
                                {edge.node.name}
                            </Link>
                        );
                    })}
                {onMoreGroups ? (
                    <FetchMoreButton
                        style={{ button: styles.fetchMoreButton }}
                        disabled={loadingOnMoreGroups}
                        loading={loadingOnMoreGroups}
                        onClick={() => {
                            setLoadingOnMoreGroups(true);
                            onMoreGroups();
                        }}
                    />
                ) : null}
            </div>
        </React.Fragment>
    );
}

export default Styled(defaultStyles)(AuthorActivity);
